export const PRODUCT_TEMPLATE_URL = "https://docs.google.com/spreadsheets/d/1YEIcbtoQU91UlWgal-fHyDMU11cYJsLv/edit?usp=sharing&ouid=115278395046390498735&rtpof=true&sd=true"

export const SUPPLIER_TEMPLATE_URL = "https://docs.google.com/spreadsheets/d/1Yg27s37sfT-rMHIe9oObrAjGo0H3d05o/edit?usp=sharing&ouid=115278395046390498735&rtpof=true&sd=true"

export const SECTORS_TEMPLATE_URL = "https://docs.google.com/spreadsheets/d/1IdAE7H89QOh7O4hScEo8MOW95c9liZvlVfgmRD8YySM/edit?usp=sharing"
  

